module.exports = "li.active a {\n  background-color: green; }\n"